var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 7.16667C10.7365 7.16667 11.3335 6.56971 11.3335 5.83333C11.3335 5.09695 10.7365 4.5 10.0001 4.5C9.26376 4.5 8.66681 5.09695 8.66681 5.83333C8.66681 6.56971 9.26376 7.16667 10.0001 7.16667ZM10.0001 11.8334C10.7365 11.8334 11.3334 11.2364 11.3334 10.5C11.3334 9.76364 10.7365 9.16669 10.0001 9.16669C9.2637 9.16669 8.66675 9.76364 8.66675 10.5C8.66675 11.2364 9.2637 11.8334 10.0001 11.8334ZM11.3334 15.1666C11.3334 15.903 10.7365 16.5 10.0001 16.5C9.2637 16.5 8.66675 15.903 8.66675 15.1666C8.66675 14.4303 9.2637 13.8333 10.0001 13.8333C10.7365 13.8333 11.3334 14.4303 11.3334 15.1666Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_732_8510",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 4,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 7.16667C10.7365 7.16667 11.3335 6.56971 11.3335 5.83333C11.3335 5.09695 10.7365 4.5 10.0001 4.5C9.26376 4.5 8.66681 5.09695 8.66681 5.83333C8.66681 6.56971 9.26376 7.16667 10.0001 7.16667ZM10.0001 11.8334C10.7365 11.8334 11.3334 11.2364 11.3334 10.5C11.3334 9.76364 10.7365 9.16669 10.0001 9.16669C9.2637 9.16669 8.66675 9.76364 8.66675 10.5C8.66675 11.2364 9.2637 11.8334 10.0001 11.8334ZM11.3334 15.1666C11.3334 15.903 10.7365 16.5 10.0001 16.5C9.2637 16.5 8.66675 15.903 8.66675 15.1666C8.66675 14.4303 9.2637 13.8333 10.0001 13.8333C10.7365 13.8333 11.3334 14.4303 11.3334 15.1666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_732_8510)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.0d44dd4ec17cb5c9d7be457678127f26.svg";
export { ForwardRef as ReactComponent };